import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgVisa(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "visa_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 24,
      height: 24
    }, {
      children: _jsx("path", {
        fill: "#C4C4C4",
        d: "M0 0h24v24H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#visa_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M0 8.115v.116c2.461.592 4.17 2.088 4.846 3.808l-.71-3.313c-.12-.453-.48-.595-.905-.61H0z",
        fill: "#F7981D"
      }, void 0), _jsx("path", {
        d: "M8.596 15.27l1.212-7.155h1.961l-1.211 7.154H8.596zM17.54 8.3a5.094 5.094 0 00-1.758-.3c-1.939 0-3.304.97-3.316 2.361-.01 1.028.975 1.6 1.72 1.943.763.35 1.02.575 1.016.888-.005.48-.61.698-1.174.698-.785 0-1.202-.108-1.847-.375l-.252-.114-.276 1.601c.458.2 1.306.373 2.186.382 2.061 0 3.4-.959 3.415-2.444.008-.814-.515-1.433-1.647-1.944-.685-.33-1.105-.551-1.1-.886 0-.298.355-.616 1.123-.616a3.637 3.637 0 011.468.274l.176.083.266-1.55zM20.884 8.115c-.47 0-.81.144-1.016.61l-2.907 6.545h2.077l.404-1.097h2.481l.23 1.097H24l-1.615-7.154h-1.5zm-.891 4.627c.162-.412.781-2 .781-2-.011.02.161-.414.26-.682l.133.616.454 2.066h-1.628zM5.019 13.02l-.173-.981c-.358-1.144-1.469-2.38-2.714-3l1.733 6.23h2.077l3.116-7.154H6.98L5.019 13.02z",
        fill: "#293688"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgVisa;